import React, { useState } from 'react';

import { Button, Input, IconX } from '@trqk/components';
import { locale } from '@trqk/utils';

/**
 * A RenderTooltipMessage component that allows the user to set the filename for downloading a
 * file.
 */
export const DownloadAs: RenderTooltipMessage<DownloadAsTooltipMessageProps> =
    ({
        body,
        close,
        fileExtension,
        handleDownloadAs,
    }: RenderTooltipMessageProps<DownloadAsTooltipMessageProps>): JSX.Element => {
        const [downloadAs, setDownloadAs] = useState('');

        return (
            <div className="px-4 pb-4 space-y-4">
                <div className="flex justify-between pb-4">
                    <h4 className="mt-3">
                        {
                            locale.enUS.GAP_ANALYSIS.REPORT_VIEWER_TABLE
                                .DOWNLOAD_AS_DIALOG.HEADER
                        }
                    </h4>
                    <button
                        className="mt-4 mb-2"
                        type="button"
                        onClick={(): void => {
                            close();
                        }}
                    >
                        <IconX width={16} fillColor="tertiary-400" />
                    </button>
                </div>
                {body ?? null}
                <div className="flex items-baseline" style={{ width: 386 }}>
                    <Input
                        addClasses="bg-tertiary-100"
                        labelClasses="flex-grow"
                        inputId="download-as-filename"
                        label={
                            locale.enUS.GAP_ANALYSIS.REPORT_VIEWER_TABLE
                                .DOWNLOAD_AS_DIALOG.FILENAME
                        }
                        handleChange={value => {
                            setDownloadAs(value);
                        }}
                        value={downloadAs}
                    />
                    <p className="pl-2">{fileExtension}</p>
                </div>
                <div className="flex justify-end pt-4 space-x-4">
                    <Button
                        autoWidth={true}
                        color="primary"
                        disabled={downloadAs.length < 1}
                        handleClick={() => {
                            handleDownloadAs(downloadAs);
                            close();
                        }}
                    >
                        <p className="px-10">Save</p>
                    </Button>
                </div>
            </div>
        );
    };
